devex = devex || {};
devex.alerts = devex.alerts || {};

/*
   NOTE: markup changes should be reflected in
         <views/shared/_flash.slim> and <views/shared/flash/*>
*/

/**
 * Shows an alert message to the user
 *
 * @param {string} message Text you want to display, can include HTML
 * @param {string} alertType Either 'info', 'warning', or 'error'.
 * Styling will be modified accordingly.
 *
 * @param {object} [options] additional options passed to the alert
 *   @param {boolean} options.sticky Prevents notification from auto-closing.
 *   Defaults to `false`
 * @returns {undefined}
 */
devex.alerts.showAlert = function(message, alertType, options) {
  var alertOptions = options || {};
  var iconClass = devex.alerts.iconClassByType(alertType);
  var alertClass = devex.alerts.alertClassByType(alertType);
  var $alertHtml = $(
    '<li class="alert-wrap">' +
    '<div class="alert z-depth-1 clearfix ' + alertClass+ '" role="alert" >' +
    '<div class="text-content" >' +
    '<i class="' + iconClass + ' icon fal"></i>' +
    '<span class="text">' + message + '</span>' +
    '</div>' +
    '<button class="close" id="dismiss-alert">' +
    '<i class="fal icon-times"></i>' +
    '</button>' +
    '</div>' +
    '</li>'
  );
  var $alertContainer = $('#alerts-container');

  var alertManager = {
    hide: function() {
      $alertContainer
        .html('')
        .removeClass('alert-wrap');
    },
    show: function(content) {
      $alertContainer
        .html(content)
        .addClass('alert-wrap');

      $('#dismiss-alert').on('click', this.hide);
      if (alertOptions.sticky) return;

      setTimeout(this.hide, 8000);
    }
  };

  alertManager.show($alertHtml);
  $alertHtml.attachBehavior();
};

devex.alerts.iconClassByType = function(type) {
  var icon = {
    success: 'icon-check',
    info: 'icon-info-circle',
    alert: 'icon-exclamation-triangle',
    error: 'icon-times-circle'
  }[type];
  return icon ? icon : 'icon-circle';
};

devex.alerts.alertClassByType = function(type) {
  var icon = {
    success: 'alert-success',
    info: 'alert-info',
    alert: 'alert-warning',
    error: 'alert-danger'
  }[type];
  return icon ? icon : 'alert-info';
};
